import * as Sentry from '@sentry/react'
import { ZodTypeAny } from 'zod'

class ZodErrorService {
  logZodError(error: unknown) {
    console.error(error)
    Sentry.captureException(error)
  }

  safeParse<T extends ZodTypeAny>(schema: T, data: unknown) {
    const result = schema.safeParse(data)
    if (!result.success) {
      this.logZodError(result.error)
    }
    return result
  }

  parse<T extends ZodTypeAny>(schema: T, data: unknown): T['_output'] {
    try {
      const result = schema.parse(data)
      return result
    } catch (error) {
      this.logZodError(error)
      throw new Error()
    }
  }
}

export const zodErrorService = new ZodErrorService()
